<template>
  <div id="saved-trips-list">
    <div
      class="saved-trip"
      v-for="(trip, i) in savedTripsOrderedByLastUpdated"
      :key="i"
    >
      <h2 class="trip-date">Sidst ændret d. {{format(new Date(trip.lastEdit), 'Do MMMM YYYY', { locale: da })}}</h2>
      <div class="trip-box">
        <!-- <h3>Til</h3> -->
        <div class="box-left">
          <div class="trip-to">
            <TitleEdit
              @click.native.stop
              v-if="editingTitle === trip.id"
              :trip="trip"
              :cancel="cancelEditingTitle"
              :save="setTripTitle"
            />
            <div
              v-else
              @click.stop="setEditingTitle(trip.id)"
              class="title"
              title="Rediger titel"
            ><span>{{trip.title}}</span><i>
                <Pen :iconColor="'#bb5cee'" /></i></div>
            <div class="details">
              <time>Afgang d. <b>{{format(trip.ud.startTime, 'Do MMMM YYYY', { locale: da })}}</b> kl. <b>{{format(trip.ud.startTime, 'HH:mm', { locale: da })}}</b></time>
              <div class="modes">
                <ModeIcon
                  v-for="mode in getTripItineraryModes(trip)"
                  :key="mode"
                  :mode="mode"
                  :color="'#0f1c70'"
                />
              </div>
            </div>
          </div>
          <div class="trip-row">
            <div
              @click.stop="copyShareUrl(getTripUrl(trip.id))"
              class="trip-url"
            >
              <LinkIcon /><span>{{getTripUrl(trip.id)}}</span>
              <div class="tool-tip"><span v-if="copying">Kopieret til udklipsholder!</span><span v-else>Klik for at kopiere linket</span></div>
            </div>
          </div>
          <div class="trip-subtext">Alle der modtager linket kan se ruten</div>
        </div>
        <div class="box-right">
          <button
            title="Se rute"
            class="filled-icon-btn"
            @click.stop="router.push(`/view/${trip.id}`)"
          >
            <Eye :iconColor="'#FFFFFF'" />
          </button>
          <button
            title="Rediger rute"
            class="filled-icon-btn"
            @click.stop="router.push(`/edit/${trip.id}`)"
          >
            <Pen :iconColor="'#FFFFFF'" />
          </button>
          <button
            title="Slet rute"
            class="filled-icon-btn delete"
            @click.stop="confirmDeleteTrip(trip)"
          >
            <TrashIcon
              :iconColor="'#FFFFFF'"
              :width="19"
            />
          </button>
        </div>
      </div>
    </div>

    <DeleteTripConfirmationModal
      v-if="showDeleteTripConfirmationModal"
      :close="closeDeleteTripConfirmationModal"
      :trip="this.tripToDelete"
      :confirm="this.deleteTrip"
    />
  </div>
</template>

<script>
import { format } from 'date-fns';
import da from 'date-fns/locale/da';
import Eye from '@/components/Icons/FilledCircleEye';
import Pen from '@/components/Icons/FilledCirclePen';
import TrashIcon from '@/components/Icons/Trash';
import LinkIcon from '@/components/Icons/Link';
import HmApi from '@/api/herningMobilitetApi';
import DeleteTripConfirmationModal from '@/components/Home/DeleteTripConfirmationModal';
import ModeIcon from '@/components/Icons/ModeIcon.vue';
import TitleEdit from '@/components/Home/TitleEdit.vue';
import { copyToClipBoard } from '@/util';
export default {
  name: 'saved-trips-list',
  components: {
    Eye,
    Pen,
    TrashIcon,
    LinkIcon,
    DeleteTripConfirmationModal,
    ModeIcon,
    TitleEdit,
  },
  props: {
    editingTitle: [String, Number],
    setEditingTitle: Function,
  },
  data: function() {
    return {
      copyToClipBoard,
      copying: false,
      router: this.$router,
      savedTrips: [],
      format,
      da,
      tripToDelete: undefined,
      showDeleteTripConfirmationModal: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    savedTripsOrderedByLastUpdated() {
      if (!this.savedTrips) {
        return [];
      }
      // concat for at unngå at mutere this.savedTrips
      return this.savedTrips.concat().sort(function(a, b) {
        return new Date(b.lastEdit) - new Date(a.lastEdit);
      });
    },
  },
  mounted() {
    if (this.$store && this.$store.state && this.$store.state.user) {
      HmApi.getTrips(this.$store.state.user).then(trips => {
        this.savedTrips = trips;
      });
    }
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'updateUser') {
        if (state.user !== null) {
          HmApi.getTrips(state.user).then(trips => {
            this.savedTrips = trips;
          });
        }
      }
    });
  },
  methods: {
    setTripTitle(id, title) {
      HmApi.updateTripTitle(id, title).then(() => {
        this.savedTrips.find(t => t.id === id).title = title;
        this.setEditingTitle(undefined);
      });
    },
    cancelEditingTitle() {
      this.setEditingTitle(undefined);
    },
    copyShareUrl(url) {
      this.copying = true;
      this.copyToClipBoard(url);
      setTimeout(() => {
        this.copying = false;
      }, 2000);
    },

    getTripItineraryModes(trip) {
      const udModes = trip.ud.itineraryModes ? trip.ud.itineraryModes : [];
      const returModes = trip.retur
        ? trip.retur.itineraryModes
          ? trip.retur.itineraryModes
          : []
        : [];
      const itineraryModes = [...new Set([...udModes, ...returModes])];
      return itineraryModes;
    },
    getTripUrl(id) {
      return `${window.location.href}view/${id}`;
    },
    confirmDeleteTrip(trip) {
      this.tripToDelete = trip;
      this.showDeleteTripConfirmationModal = true;
    },
    closeDeleteTripConfirmationModal() {
      this.showDeleteTripConfirmationModal = false;
      this.tripToDelete = undefined;
    },
    deleteTrip() {
      if (this.tripToDelete) {
        const { id } = this.tripToDelete;
        HmApi.deleteTrip(id).then(trip => {
          HmApi.getTrips(this.$store.state.user).then(trips => {
            this.savedTrips = trips;
          });
        });
      }

      this.tripToDelete = undefined;
      this.showDeleteTripConfirmationModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modes {
  display: flex;
}
#saved-trips-list {
  padding-bottom: 50px;
  max-width: 725px;
  width: 85%;

  .saved-trip {
    margin-top: 30px;
    display: flex;
    flex-direction: column;

    .trip-date {
      color: hsla(232, 76%, 25%, 0.4);
      font-size: 13px;
      font-weight: 600;
      b {
        font-weight: 700;
      }
    }
    .trip-box {
      background: #ffffff;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
      min-height: 225px;
      display: flex;
      flex-direction: row;
      border-radius: 6px;
      .box-left {
        width: 85%;
        border-right: 1px solid #e6e7ee;
        padding: 50px;
        padding-right: 35px;
        h3 {
          font-size: 13px;
          font-weight: 600;
          color: #c0c3d8;
          margin: 0 0 8px 0;
        }
        .trip-to {
          font-size: 19px;
          font-weight: 600;
          color: #0f1c70;
          margin-bottom: 25px;
          div {
            display: block;
            b {
              font-weight: 600;
            }
          }
          .title {
            span,
            i {
              display: inline-block;
              cursor: pointer;
              vertical-align: middle;
            }
            span {
              max-width: 90%;
              overflow: hidden;
              padding-right: 15px;
            }
            i {
              vertical-align: middle;
              opacity: 0.3;
              transition: 0.3s;
              margin-top: 3px;
            }
            &:hover i {
              opacity: 1;
            }
          }
          .details {
            font-size: 14px;
            font-weight: 400;
            margin-top: 9px;
            time {
              display: inline-block;
              padding-right: 10px;
            }
            .modes {
              display: inline-block;
              margin-top: 6px;
              opacity: 0.5;
              .mode-icon {
                display: inline-block;
                vertical-align: middle;
                padding-right: 8px;
              }
            }
          }
        }
        .trip-row {
          display: flex;
        }
        .trip-url {
          cursor: pointer;
          height: 46px;
          width: 100%;
          background-color: #f8eefd;
          color: #bb5cee;
          border-radius: 4px;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          align-items: center;
          padding: 0 20px 0 14px;
          position: relative;
          transition: 0.1s;
          &:hover {
            color: #9900ea;
          }
          svg {
            display: inline-block;
            margin-right: 8px;
            opacity: 0.3;
            transition: 0.1s;
          }
          span {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            // width: 80%;
            text-overflow: ellipsis;
          }
          .tool-tip {
            bottom: -2em;
            left: 50%;
            transform: translateX(-50%);
          }
          &:hover .tool-tip {
            display: block;
          }
          &:hover svg {
            opacity: 1;
          }
        }
        .trip-subtext {
          margin-top: 12px;
          color: #9399bf;
          font-size: 12px;
        }
      }
      .box-right {
        padding: 50px 35px;
        padding-right: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      button {
        background: none;
        color: inherit;
        border: none;
        border-radius: 100%;
        padding: 0;
        font: inherit;
        cursor: pointer;
        flex-shrink: 0;
        margin: 6px 0;
      }
      .filled-icon-btn {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        background-color: #bb5cee;
        display: flex;
        justify-content: space-around;
        align-items: center;
        transition: 0.2s;
        &:hover {
          opacity: 0.8;
        }
      }
      .filled-icon-btn.delete {
        background-color: #8a91c1;
      }
    }
  }
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  #saved-trips-list {
    .saved-trip {
      margin-top: 30px;
      .trip-box {
        .box-right,
        .box-left {
          padding: 38px;
        }
        .box-right {
          padding-left: 25px;
        }
        .box-left {
          padding-right: 30px;
        }
        button {
          margin-left: 6px;
        }
      }
    }
  }
}

@media only screen and (max-width: $mobile-max-width) {
  #saved-trips-list {
    .saved-trip {
      margin-top: 20px;
      .trip-box {
        flex-direction: column;
        .box-left {
          width: 100%;
          border-right: none;
          border-bottom: 1px solid #e6e7ee;
          padding: 28px;
          .trip-to {
            margin-bottom: 18px;
            .details {
              // margin-top: 4px;
            }
          }
        }
        .box-right {
          flex-direction: row-reverse;
          padding: 12px 28px;
        }
        .filled-icon-btn {
          margin-left: 15px;
        }
      }
    }
    .trip-subtext {
      text-align: center;
    }
  }
}
</style>
